// lazy-loading.js
document.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll('.card__media img');
  
  images.forEach(img => {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', function() {
        this.classList.add('loaded');
      });
    }
  });
});